import {exeRequest} from '../utils/APIUtils'

export default {
 get : async  (clientId) => exeRequest(`/clients/${clientId}/concessionnaires`, "GET"),
 getAll : async  () => exeRequest(`/concessionnaires`, "GET"),
 search : async  (term, abort) => exeRequest(`/concessionnaires/search/${term}`, "GET", null, abort)
}